import {Component, OnDestroy} from '@angular/core';
import {OktaService} from '../../shared/_services/okta.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnDestroy {

  oktaError: string;

  // DESTROY SUBJECT
  onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    public oktaService: OktaService,
  ) {
    this.onOktaError();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private onOktaError(): void {
    this.oktaService.onNewOktaError()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (err) => {
          this.oktaError = err;
        }
      );
  }

  oktaTryAgain(): void {
    this.oktaService.forceRetry();
  }

  contactUs(): void {
    const tempBody = 'It seems I don\'t have okta access to WARP, could you help me?';
    window.location.href = `mailto:st.optimization@engie.com?subject=No WARP access&body=${tempBody}`;
  }

}
